import React, { FC } from 'react'

import { AirbnbPropertyCategoryType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface PropertyTypeFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  options?: { value: string; label: string }[]
}

export const PropertyTypeFilter: FC<PropertyTypeFilterProps> = props => {
  const { options } = props

  const optionsToUse =
    options ||
    Object.keys(AirbnbPropertyCategoryType).map(propertyType => ({
      value: AirbnbPropertyCategoryType[propertyType as keyof typeof AirbnbPropertyCategoryType],
      label: capitalizeEachFirstLetter(
        AirbnbPropertyCategoryType[propertyType as keyof typeof AirbnbPropertyCategoryType],
      ).replace(/_/g, ' '),
    }))

  return <CheckboxBasedFilter title="Property Type" options={optionsToUse} {...props} />
}
